import { Call, Device as TwilioDevice } from '@twilio/voice-sdk';

let twilioDevice: TwilioDevice | null = null;
let activeCall: Call | null = null;

export const registerTwilioDevice = (device: TwilioDevice | null): void => {
  twilioDevice = device;
};

export const registerActiveTwilioCall = (call: Call | null): void => {
  activeCall = call;
};

export const isCallInProgress = (): boolean => activeCall !== null;

export const destroyTwilioDevice = async (force = false): Promise<void> => {
  if (activeCall) {
    if (!force) return;

    activeCall?.reject();
    activeCall?.disconnect();
    activeCall = null;
  }
  if (twilioDevice) {
    try {
      await twilioDevice?.unregister();
    } catch (e) {
      console.error('Error in unregistering device', e);
    }
    try {
      await twilioDevice?.destroy();
    } catch (e) {
      console.error('failed to destroy device', e);
    }

    twilioDevice = null;
  }
};
